import { render, staticRenderFns } from "./yongyaopeiwufenxi.vue?vue&type=template&id=4c2a79dd&"
import script from "./yongyaopeiwufenxi.vue?vue&type=script&lang=ts&"
export * from "./yongyaopeiwufenxi.vue?vue&type=script&lang=ts&"
import style0 from "./yongyaopeiwufenxi.vue?vue&type=style&index=0&id=4c2a79dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports